import { useState } from "react"

import { useTranslation } from "lib/i18n/translation"
import { useModal } from "lib/modal"
import Products from "components/common/products"
import ListLetter from "components/modals/list-letter.js"

import Film from "./list/film"

const FORMATIVE_LIST = "Liste formative"
const ALTERNATIVE_LIST = "Liste alternative"

export default ({ list, director, loading }) => {
	const { c } = useTranslation("common")
	const { show } = useModal()

	const [listDisplay, setListDisplay] = useState(FORMATIVE_LIST)
	let formativeList, alternativeList

	if (list.otherLists && list.otherLists.length > 0) {
		formativeList = list.otherLists.find(l => l.name == FORMATIVE_LIST)
		alternativeList = list.otherLists.find(l => l.name == ALTERNATIVE_LIST)
	}

	const showLetter = () => {
		show({
			id: "list-letter-modal",
			children: <ListLetter letterId={list.letterId} />,
			className: "slide left"
		})
	}

	return (
		<section>
			<h2 className="section-title icon-chair">{c("director-list-strong")}</h2>
			<p className={loading ? "skeleton" : ""} dangerouslySetInnerHTML={{__html: list.descriptionShort}} />
			{ list.letterId
				? <p className="centered">
						<a
							href="#"
							rel="nofollow noopener"
							title="Voir la lettre"
							data-overlay="#overlay-letter"
							className="button"
							onClick={e => { e.preventDefault(); showLetter() }}
						>
							{c("open-letter")}
						</a>
					</p>
				: null
			}

			{ !loading && list.otherLists && list.otherLists.length > 0
				? <nav data-tabs="#tabs-films-list" className="nav-tabs">
						<a
							href="#"
							rel="nofollow noopener"
							title={c("formative-list")}
							className={`${listDisplay == FORMATIVE_LIST ? "active" : ""} ${loading ? "skeleton" : ""}`}
							onClick={e => { e.preventDefault(); setListDisplay(FORMATIVE_LIST) }}
						>
							<span>{c("formative-list")}</span>
						</a>
						<a
							href="#"
							rel="nofollow noopener"
							title={c("alternative-list")}
							className={`${listDisplay == ALTERNATIVE_LIST ? "active" : ""} ${loading ? "skeleton" : ""}`}
							onClick={e => { e.preventDefault(); setListDisplay(ALTERNATIVE_LIST) }}
						>
							<span>{c("alternative-list")}</span>
						</a>
					</nav>
				: null
			}
			<ul id="tabs-films-list" className="tabs">
				{ !loading && list.otherLists && list.otherLists.length > 0
					? <>
							{ formativeList
								? <List
										displayKey={FORMATIVE_LIST}
										currentDisplayKey={listDisplay}
										list={formativeList}
										director={director}
									/>
								: null
							}
							{ alternativeList
								? <List
										displayKey={ALTERNATIVE_LIST}
										currentDisplayKey={listDisplay}
										list={alternativeList}
										director={director}
									/>
								: null
							}
						</>
					: list.categories && list.categories.length
						? <li className="tab active">
								{ list.categories.map(category => (
										<>
											<h3 className="list-title">{category.name}</h3>
											{ category.descriptionShort && category.descriptionShort !== ""
												? <p>{category.descriptionShort}</p>
												: null
											}
											<FilmsList list={category} director={director} loading={loading} />
										</>
								)) }
							</li>
						: <List list={list} director={director} loading={loading} />
				}
			</ul>
		</section>
	)
}

const List = ({ displayKey, currentDisplayKey, list, title, director, loading }) => {
	return (
		<li className={`tab ${(!displayKey || displayKey == currentDisplayKey) ? "active" : ""}`}>
			<FilmsList list={list} director={director} loading={loading} />
		</li>
	)
}

const FilmsList = ({ list, director, loading }) => {
	const { c } = useTranslation("common")

	const products = !Array.isArray(list.products) ? list.products.items.map(p => p.id) : list.products
	const hasComments = products.find(p => c(`list-comment-${list.id}-${p}`) !== `list-comment-${list.id}-${p}`) !== undefined

	return (
		<Products products={products.map(id => ({ id }))} getFilmsForced>
			{ (products, loading) => (
					<ul className={`list films director-list has-comments`}>
						{ products.map((product, index) => (
							<Film
								film={product}
								list={list}
								director={director}
								loading={product.id == 9999999 || loading}
								hasComments={hasComments}
								key={`product-${index}-${loading}`}
							/>
						))}
					</ul>
			)}
		</Products>
	)
}
